// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class NominationAssignment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get status() {
        return `${this.accepted ? 'Accepted' : this.declined ? 'Declined' : 'Pending'}`;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accepted?: Date;
  closed?: Date;
  confirmed?: Date;
  created?: Date;
  createdBy?: string;
  declined?: Date;
  deleted?: Date;
  note?: string;
  personId!: number;
  role?: string;
  person!: Person;
}

